import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { ChatActions } from '../store/chats.actions';
import type { ChatsState } from '../store/chats.reducer';
import type { ConversationPage } from './conversation.page';

/**
 * Guard that performs cleanup actions when navigating away from the conversation page.
 * Always allows navigation, but ensures the assistant profile is closed when leaving the conversation route.
 */
export const conversationCanDeactivateGuard = (
  component: ConversationPage,
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  nextState?: RouterStateSnapshot,
) => {
  const chatsStore = inject<Store<ChatsState>>(Store);
  const isNavigatingAwayFromConversationPage =
    state?.url.includes('conversation') &&
    !nextState?.url.includes('conversation');

  /**
   * If the user is navigating away from the conversation page,
   * close the assistant profile
   */
  if (isNavigatingAwayFromConversationPage) {
    chatsStore.dispatch(ChatActions.closeAssistantProfile());
  }

  return true;
};
